/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Of_ContentsInputs */

const en_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table of Contents`)
};

const tr_table_of_contents = /** @type {(inputs: Table_Of_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçindekiler`)
};

/**
* | output |
* | --- |
* | "Table of Contents" |
*
* @param {Table_Of_ContentsInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const table_of_contents = /** @type {((inputs?: Table_Of_ContentsInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Of_ContentsInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_of_contents(inputs)
	return tr_table_of_contents(inputs)
});